import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.stiv_apps.facecutweb.pages.HomePage as _com_stiv_apps_facecutweb_pages_HomePage
import com.stiv_apps.facecutweb.pages.PrivacyPolicyPage as _com_stiv_apps_facecutweb_pages_PrivacyPolicyPage
import com.stiv_apps.facecutweb.pages.TermsOfServicePage as _com_stiv_apps_facecutweb_pages_TermsOfServicePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "FaceCut – Portrait Thumbnails"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_stiv_apps_facecutweb_pages_HomePage()
        }
        ctx.router.register(
            "/privacy",
        ) { pageCtx -> 
            _com_stiv_apps_facecutweb_pages_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/terms",
        ) { pageCtx -> 
            _com_stiv_apps_facecutweb_pages_TermsOfServicePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("logo", com.stiv_apps.facecutweb.style.LogoStyle)
        ctx.theme.registerStyle("store-image", com.stiv_apps.facecutweb.style.StoreImageStyle)
        ctx.theme.registerStyle("text-selection", com.stiv_apps.facecutweb.style.TextSelectionStyle)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.stiv_apps.facecutweb.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
